import { render, staticRenderFns } from "./ButtonAddQuestion.vue?vue&type=template&id=5ae28123&scoped=true&"
import script from "./ButtonAddQuestion.vue?vue&type=script&lang=js&"
export * from "./ButtonAddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddQuestion.vue?vue&type=style&index=0&id=5ae28123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae28123",
  null
  
)

export default component.exports